export default "__VITE_ASSET__MuThlX4z__"